import { useEffect, useState, useRef, useCallback } from "react";
import { MainLayout } from "../components/layout/MainLayout";
import { Header } from "../components/layout/Header";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../components/ui/table";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import {
  Plus,
  Trash2,
  Save,
  Send,
  ArrowLeft,
  Search,
  X,
  Package,
  AlertTriangle,
  Zap,
  CheckCircle2,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { cn } from "../lib/utils";
import {
  get_purchase_master_data,
  save_update_purchase,
  server_post_data,
} from "../ServiceConnection/serviceconnection.js";
import { handleError, handleSuccess } from "../CommonJquery/CommonJquery.js";
import Loader from "../components/layout/Loader.js";
import { retrieveData } from "../LocalConnection/LocalConnection.js";

export default function CreatePO() {
  const navigate = useNavigate();
  const searchInputRef = useRef(null);
  const suggestionsRef = useRef(null);

  // State management
  const [selectedDepartment, setSelectedDepartment] = useState("Kitchen");
  const [selectedDepartmentID, setSelectedDepartmentID] = useState("0");
  const [selectedDepartmentIndex, setSelectedDepartmentIndex] = useState("0");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState("0");
  const [selectedCategoryID, setSelectedCategoryID] = useState("0");
  const [selectedVendor, setSelectedVendor] = useState("");
  const [selectedVendorID, setSelectedVendorID] = useState("0");
  const [SelectedVendorIndex, setSelectedVendorIndex] = useState("0");
  const [poItems, setPOItems] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [categories, setcategories] = useState([]);
  const [masterItemList, setmasterItemList] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(0);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [showLoader, setshowLoader] = useState(false);
  const [adminName, setadminName] = useState("");
  const [purchaseUnitTypes, setPurchaseUnitTypes] = useState([]);
  const [unitTypes, setUnitTypes] = useState([]);
  const [justAddedItem, setJustAddedItem] = useState(null);

  useEffect(() => {
    let status = "all";
    let search = "";
    master_data_get(status, search);
  }, []);

  // Auto-focus search input on mount and when suggestions close
  useEffect(() => {
    if (searchInputRef.current && !showSuggestions) {
      searchInputRef.current.focus();
    }
  }, [showSuggestions]);

  const master_data_get = async (status, search) => {
    setadminName(retrieveData("admin_name"));
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("status", status);
    fd.append("search", search);
    await server_post_data(get_purchase_master_data, fd)
      .then((Response) => {
        console.log(Response.data.message);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          const { departments, vendors, items, purchase_type, units } =
            Response.data.message;

          setDepartments(departments);
          setVendors(vendors);
          setmasterItemList(items);
          setPurchaseUnitTypes(purchase_type || []); // purchase_type array from API
          setUnitTypes(units);
          // auto-select first department safely
          if (departments.length > 0) {
            setSelectedDepartment(departments[0].department_name);
            setSelectedDepartmentID(departments[0].primary_id);
            setcategories(departments[0].categories || []);
          }
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleSaveChanges = async () => {
    setshowLoader(true);

    const itemsForSave = poItems.map((i) => ({
      ingredient_id: i.ingredient_id,
      quantity: parseFloat(i.quantity),
      unit: i.unit,
      default_unit_id: i.default_unit_id,
      purchaseUnitType: i.purchaseUnitType,
      sizePerPacket: parseFloat(i.sizePerPacket) || 1,
      name: i.name,
      alter_name: i.alter_name,
    }));

    const fd = new FormData();
    fd.append("purchase_id", "0");
    fd.append("department_id", selectedDepartmentID);
    fd.append("department_name", selectedDepartment);
    fd.append("vendor_id", selectedVendorID);
    fd.append("vendor_name", selectedVendor);
    fd.append("remarks", remarks);
    fd.append("terms_of_payment", "");
    fd.append("terms_of_delivery", "0");
    fd.append("total_items", poItems.length);
    fd.append("extra_amount", "0");
    fd.append("grand_amount", "0");
    fd.append("items", JSON.stringify(itemsForSave));

    try {
      const response = await server_post_data(save_update_purchase, fd);

      if (response.data.error) {
        handleError(response.data.message);
      } else {
        const pos = response.data.pos || [];
        let message = "Purchase Order(s) created successfully!\n\n";
        pos.forEach((po, index) => {
          message += `${index + 1}. ${po.purchase_order_no} → ${po.status}\n`;
        });

        handleSuccess("Success", message.trim());
        navigate("/purchase-orders");
      }
    } catch (error) {
      handleError("network");
    } finally {
      setshowLoader(false);
    }
  };

  // Search items function
  const searchItems = (query, department) => {
    const lowercaseQuery = query.toLowerCase();
    return masterItemList.filter((item) => {
      //return item.name.toLowerCase().includes(lowercaseQuery) && (!department || item.department_name === department);
      // 1. Name check (with null safety)
      let matchesName = item.name?.toLowerCase().includes(lowercaseQuery);

      // 2. Alter Name check (with null safety)
      let matchesAlterName = item.alter_name
        ?.toLowerCase()
        .includes(lowercaseQuery);

      // 3. Department check
      let matchesDepartment =
        !department || item.department_name === department;

      // Logic: (Name OR Alter Name match hona chahiye) AND Department sahi hona chahiye
      return (matchesName || matchesAlterName);
    });
  };

  // Search suggestions
  const searchSuggestions =
    searchQuery.length >= 2
      ? searchItems(searchQuery, selectedDepartment).slice(0, 10)
      : [];

  // Get vendors for selected department
  const departmentVendors = vendors[selectedDepartment] || [];

  const handleDepartmentChange = (index) => {
    setSelectedDepartment(departments[index].department_name);
    setSelectedDepartmentIndex(index);
    setSelectedDepartmentID(departments[index].primary_id);
    setSelectedVendor("");
    setSelectedVendorIndex("0");
    setSelectedVendorID("0");
    setSelectedCategory("");
    setSelectedCategoryIndex("0");
    setSelectedCategoryID("0");
    setcategories(departments[index].categories);
    setPOItems([]);
    setSearchQuery("");
    setShowSuggestions(false);
  };

  const handleCategoryChange = (index) => {
    setSelectedCategory(categories[index].dcategory_name);
    setSelectedCategoryIndex(index);
    setSelectedCategoryID(categories[index].primary_id);
  };

  const handleVendorChange = (index) => {
    setSelectedVendor(departmentVendors[index].vendor_name);
    setSelectedVendorIndex(index);
    setSelectedVendorID(departmentVendors[index].primary_id);
  };

  // Add item with real purchase_type & each_container from ingredient
  const handleAddItem = useCallback(
    (item) => {
      const existing = poItems.find((p) => p.itemId === item.id);
      if (existing) {
        setJustAddedItem(item.id);
        setTimeout(() => setJustAddedItem(null), 1000);
        return;
      }

      const newItem = {
        id: Date.now().toString(),
        itemId: item.id,
        ingredient_id: item.ingredient_id,
        name: item.name,
        alter_name: item.alter_name,
        category: item.category,
        dcategory_name: item.category,
        quantity: 1,
        unit: item.unit,
        unit_short_name: item.short_code_name,
        default_unit_id: item.default_unit_id,
        currentStock: item.currentStock,
        purchaseUnitType: item.purchase_type || "Loose", // ← from API
        sizePerPacket: parseFloat(item.each_container) || 1, // ← from API
        originalPurchaseUnitType: item.purchase_type, // Store original value for filtering
      };

      console.log(
        "Added item:",
        item.name,
        "purchase_type:",
        item.purchase_type,
      ); // Debug

      setPOItems((prev) => [...prev, newItem]);

      setJustAddedItem(item.id);
      setTimeout(() => setJustAddedItem(null), 1000);

      setSearchQuery("");
      setShowSuggestions(false);
      setSelectedSuggestionIndex(0);

      setTimeout(() => {
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }, 100);
    },
    [poItems],
  );

    // Sirf same family ke units (Atta pe ML/Litre nahi)
  const unitsForItem = useCallback(
    (item) => {
      const anchor = unitTypes.find(
        (u) => Number(u.primary_id) === Number(item.default_unit_id),
      );
      if (!anchor) return unitTypes;
      const parentId = Number(anchor.parent_unit_id) || Number(anchor.primary_id);
      return unitTypes.filter(
        (u) => Number(u.parent_unit_id) === parentId,
      );
    },
    [unitTypes],
  );

  // Keyboard navigation handler
  const handleKeyDown = useCallback(
    (e) => {
      if (!showSuggestions || searchSuggestions.length === 0) return;

      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          setSelectedSuggestionIndex((prev) =>
            prev < searchSuggestions.length - 1 ? prev + 1 : prev,
          );
          break;
        case "ArrowUp":
          e.preventDefault();
          setSelectedSuggestionIndex((prev) => (prev > 0 ? prev - 1 : 0));
          break;
        case "Enter":
          e.preventDefault();
          if (searchSuggestions[selectedSuggestionIndex]) {
            handleAddItem(searchSuggestions[selectedSuggestionIndex]);
          }
          break;
        case "Escape":
          e.preventDefault();
          setShowSuggestions(false);
          setSearchQuery("");
          setSelectedSuggestionIndex(0);
          break;
        default:
          break;
      }
    },
    [
      showSuggestions,
      searchSuggestions,
      selectedSuggestionIndex,
      handleAddItem,
    ],
  );

  // Scroll selected suggestion into view
  useEffect(() => {
    if (suggestionsRef.current && showSuggestions) {
      const selectedElement =
        suggestionsRef.current.children[selectedSuggestionIndex];
      if (selectedElement) {
        selectedElement.scrollIntoView({
          block: "nearest",
          behavior: "smooth",
        });
      }
    }
  }, [selectedSuggestionIndex, showSuggestions]);

  // Update handlers
  const handleUpdateQuantity = (id, quantity) => {
    setPOItems(
      poItems.map((item) => (item.id === id ? { ...item, quantity } : item)),
    );
  };

  const handleUpdatePurchaseUnitType = (id, purchaseUnitType) => {
    setPOItems(
      poItems.map((item) =>
        item.id === id
          ? {
            ...item,
            purchaseUnitType,
            sizePerPacket:
              // purchaseUnitType === "Loose" ? 1 : item.sizePerPacket,
              purchaseUnitType === "Loose"
                ? item.sizePerPacket
                : item.sizePerPacket,
            quantity: purchaseUnitType === "Loose" ? 1 : item.quantity,
          }
          : item,
      ),
    );
  };

  const handleUpdateSizePerPacket = (id, sizePerPacket) => {
    setPOItems(
      poItems.map((item) =>
        item.id === id ? { ...item, sizePerPacket } : item,
      ),
    );
  };

  const handleUpdateUnit = (id, unitId) => {
    const selectedUnit = unitTypes.find(
      (type) => type.primary_id.toString() === unitId,
    );

    setPOItems(
      poItems.map((item) =>
        item.id === id
          ? {
            ...item,
            default_unit_id: unitId,
            unit: selectedUnit ? selectedUnit.short_code_name : item.unit,
          }
          : item,
      ),
    );
  };

  const handleRemoveItem = (id) => {
    setPOItems(poItems.filter((item) => item.id !== id));
  };

  // Get stock display
  const getStockDisplay = (item) => {
    if (item.department === "Bar") {
      if (item.category === "Beer") {
        return `${item.currentStock} bottles`;
      }
      return `${item.currentStock} Ltr / ${item.currentStock} bottles`;
    }
    return `${item.currentStock} ${item.unit}`;
  };

  // Get low stock items
  const lowStockItems = masterItemList
    .filter(
      (item) =>
        item.department_name === selectedDepartment &&
        item.currentStock <= item.minStock,
    )
    .slice(0, 5);

  // Get stock badge
  const getStockBadge = (item) => {
    const masterItem = masterItemList.find(
      (m) => m.ingredient_id === item.ingredient_id,
    );
    if (!masterItem) return null;

    if (masterItem.currentStock <= 0) {
      return (
        <Badge variant="destructive" className="text-[10px]">
          Out
        </Badge>
      );
    } else if (masterItem.currentStock <= masterItem.minStock) {
      return (
        <Badge className="text-[10px] bg-amber-100 text-amber-700 border-amber-300">
          Low
        </Badge>
      );
    }
    return (
      <Badge className="text-[10px] bg-emerald-100 text-emerald-700 border-emerald-300">
        In Stock
      </Badge>
    );
  };

  return (
    <MainLayout>
      <Header
        title="Create Purchase Order"
        subtitle="Fast keyboard-driven workflow → Type, Arrow keys, Enter to add"
      />

      <div className="p-6 space-y-6">
        {/* Header with workflow */}
        <div className="flex items-center justify-between">
          <Button
            variant="ghost"
            onClick={() => navigate("/purchase-orders")}
            className="gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </Button>
          <div className="flex items-center gap-2 text-xs">
            <span className="px-3 py-1.5 rounded-full bg-primary text-primary-foreground font-medium">
              1. Create
            </span>
            <span className="text-muted-foreground">→</span>
            <span className="px-3 py-1.5 rounded-full bg-muted text-muted-foreground">
              2. Approval
            </span>
            <span className="text-muted-foreground">→</span>
            <span className="px-3 py-1.5 rounded-full bg-muted text-muted-foreground">
              3. Send
            </span>
            <span className="text-muted-foreground">→</span>
            <span className="px-3 py-1.5 rounded-full bg-muted text-muted-foreground">
              4. GRN
            </span>
          </div>
        </div>

        {/* Main Content - Full Width */}
        <div className="space-y-6">
          {/* Compact Top Section */}
          <Card>
            <CardContent className="pt-6">
              <div className="grid grid-cols-4 gap-4">
                <div className="space-y-2">
                  <Label className="text-xs">Created By</Label>
                  <Input
                    value={adminName}
                    disabled
                    className="h-9 text-sm bg-muted"
                  />
                </div>
                <div className="space-y-2">
                  <Label className="text-xs">Date</Label>
                  <Input
                    value={new Date().toLocaleDateString("en-IN")}
                    disabled
                    className="h-9 text-sm bg-muted"
                  />
                </div>
                <div className="space-y-2">
                  <Label className="text-xs">Department *</Label>
                  <Select
                    value={selectedDepartmentIndex}
                    onValueChange={handleDepartmentChange}
                  >
                    <SelectTrigger className="h-9 text-sm">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {departments.map((dept, index) => (
                        <SelectItem key={index} value={index}>
                          {dept.department_name}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div className="space-y-2">
                  <Label className="text-xs">Vendor *</Label>
                  <Select
                    value={SelectedVendorIndex}
                    onValueChange={handleVendorChange}
                  >
                    <SelectTrigger className="h-9 text-sm">
                      <SelectValue placeholder="Select Vendor" />
                    </SelectTrigger>
                    <SelectContent>
                      {departmentVendors.map((vendor, index) => (
                        <SelectItem key={index} value={index}>
                          {vendor.vendor_name}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* QUICK ADD SECTION */}
          <Card className="border-2 border-primary/20">
            <CardHeader className="pb-3">
              <div className="flex items-center gap-2">
                <Zap className="w-5 h-5 text-primary" />
                <CardTitle className="text-lg">Quick Add Items</CardTitle>
              </div>
              <CardDescription>
                Type to search → Use ↑↓ arrows → Press Enter to add
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="relative">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
                <Input
                  ref={searchInputRef}
                  placeholder={`Search ${selectedDepartment} items... (Type 2+ characters)`}
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setShowSuggestions(true);
                    setSelectedSuggestionIndex(0);
                  }}
                  onKeyDown={handleKeyDown}
                  onFocus={() =>
                    searchQuery.length >= 2 && setShowSuggestions(true)
                  }
                  className="h-12 pl-12 pr-12 text-base border-2 focus:border-primary"
                />
                {searchQuery && (
                  <Button
                    variant="ghost"
                    size="sm"
                    className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 p-0"
                    onClick={() => {
                      setSearchQuery("");
                      setShowSuggestions(false);
                      setSelectedSuggestionIndex(0);
                      searchInputRef.current?.focus();
                    }}
                  >
                    <X className="w-4 h-4" />
                  </Button>
                )}
              </div>

              {showSuggestions && searchSuggestions.length > 0 && (
                <div
                  ref={suggestionsRef}
                  className="border-2 border-primary/30 rounded-lg overflow-hidden max-h-[320px] overflow-y-auto bg-card"
                >
                  {searchSuggestions.map((item, index) => {
                    const isAdded = poItems.some((p) => p.itemId === item.id);
                    const isSelected = index === selectedSuggestionIndex;
                    const isJustAdded = justAddedItem === item.id;
                    const isLowStock = item.currentStock <= item.minStock;
                    const isOutOfStock = item.currentStock <= 0;

                    return (
                      <button
                        key={item.id}
                        className={cn(
                          "w-full px-4 py-3 text-left flex items-center justify-between gap-3 border-b border-border last:border-0 transition-all",
                          isSelected &&
                          "bg-primary/10 border-l-4 border-l-primary",
                          isAdded && "opacity-60 cursor-not-allowed",
                          isJustAdded && "bg-success/20 animate-pulse",
                          !isSelected && !isAdded && "hover:bg-muted/50",
                        )}
                        onClick={() => !isAdded && handleAddItem(item)}
                        disabled={isAdded}
                      >
                        <div className="flex items-center gap-3 flex-1">
                          {isAdded ? (
                            <CheckCircle2 className="w-5 h-5 text-success flex-shrink-0" />
                          ) : (
                            <Plus
                              className={cn(
                                "w-5 h-5 flex-shrink-0",
                                isSelected
                                  ? "text-primary"
                                  : "text-muted-foreground",
                              )}
                            />
                          )}
                          <div className="flex-1">
                            <p className="font-semibold text-sm text-foreground">
                              {item.alter_name || item.name}
                            </p>

                            {/* Bracket Name: Sirf tab dikhega jab dono exist karte hon aur alag hon */}
                            {item.name &&
                              item.alter_name &&
                              item.name?.trim() !== item.alter_name?.trim() && (
                                <span className="text-muted-foreground text-[11px] font-normal">
                                  ({item.name})
                                </span>
                              )}
                            <div className="flex items-center gap-2 mt-0.5">
                              <span className="text-xs text-muted-foreground">
                                {item.category}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="text-right">
                            <div className="flex items-center gap-1.5">
                              <Package
                                className={cn(
                                  "w-4 h-4",
                                  isOutOfStock && "text-destructive",
                                  isLowStock &&
                                  !isOutOfStock &&
                                  "text-amber-500",
                                  !isLowStock &&
                                  !isOutOfStock &&
                                  "text-emerald-500",
                                )}
                              />
                              <span
                                className={cn(
                                  "text-sm font-bold",
                                  isOutOfStock && "text-destructive",
                                  isLowStock &&
                                  !isOutOfStock &&
                                  "text-amber-600",
                                  !isLowStock &&
                                  !isOutOfStock &&
                                  "text-emerald-600",
                                )}
                              >
                                {getStockDisplay(item)}
                              </span>
                            </div>
                          </div>
                          {(isLowStock || isOutOfStock) && (
                            <AlertTriangle
                              className={cn(
                                "w-4 h-4",
                                isOutOfStock
                                  ? "text-destructive"
                                  : "text-amber-500",
                              )}
                            />
                          )}
                        </div>
                      </button>
                    );
                  })}
                </div>
              )}

              {showSuggestions &&
                searchQuery.length >= 2 &&
                searchSuggestions.length === 0 && (
                  <div className="border-2 border-dashed rounded-lg p-6 text-center">
                    <p className="text-muted-foreground">
                      No items found matching "{searchQuery}"
                    </p>
                  </div>
                )}

              {/* Help Text */}
              <div className="bg-muted/50 rounded-lg p-3">
                <p className="text-xs text-muted-foreground flex items-center gap-2">
                  <span className="font-semibold text-foreground">
                    💡 Quick Tips:
                  </span>
                  Use ↑↓ arrows to navigate • Press Enter to add • Esc to close
                  • Auto-focuses after each add
                </p>
              </div>
            </CardContent>
          </Card>

          {/* PO ITEMS TABLE */}
          {poItems.length > 0 && (
            <Card>
              <CardHeader>
                <div className="flex items-center justify-between">
                  <CardTitle className="text-lg">
                    PO Items ({poItems.length})
                  </CardTitle>
                  <Badge
                    variant="outline"
                    className="bg-primary/10 text-primary"
                  >
                    {poItems.length} items added
                  </Badge>
                </div>
              </CardHeader>
              <CardContent>
                <div className="rounded-lg border overflow-hidden">
                  <Table>
                    <TableHeader>
                      <TableRow className="bg-muted/50">
                        <TableHead className="font-semibold">Item</TableHead>
                        <TableHead className="text-center font-semibold">Stock</TableHead>
                        <TableHead className="text-center font-semibold">
                          Purchase Type
                        </TableHead>
                        <TableHead className="text-center font-semibold">Packs</TableHead>
                        <TableHead className="text-center font-semibold">
                        Qty <br /><i className="font-normal">per Packs</i>
                        </TableHead>
                        <TableHead className="text-center font-semibold">Unit</TableHead>
                        <TableHead className="text-center font-semibold">Total</TableHead>
                        <TableHead className="w-10"></TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {poItems.map((item, index) => {
                        const masterItem = masterItemList.find(
                          (m) => m.ingredient_id === item.ingredient_id,
                        );
                        console.log(poItems);
                        const isLowStock =
                          masterItem &&
                          masterItem.currentStock <= masterItem.minStock;

                        return (
                          <TableRow key={index}>
                            {/* Item Name ---------------------------------- */}
                            <TableCell>
                              <div className="flex items-center gap-2">
                                <div>
                                  <p className="font-medium">
                                    {item.alter_name || item.name}
                                  </p>

                                  {/* Brackets logic: Sirf tab dikhao jab dono exist karein aur alag hon */}
                                  {item.name &&
                                    item.alter_name &&
                                    item.name?.trim().toLowerCase() !==
                                    item.alter_name?.trim().toLowerCase() && (
                                      <span className="text-muted-foreground text-[11px] font-normal">
                                        ({item.name})
                                      </span>
                                    )}
                                  <p className="text-xs text-muted-foreground">
                                    {item.dcategory_name}
                                  </p>
                                </div>
                                {getStockBadge(item)}
                              </div>
                            </TableCell>
                            {/* Stock Count ------------------------------- */}
                            <TableCell className="text-center">
                              <span
                                className={cn(
                                  "text-sm font-medium",
                                  isLowStock && "text-amber-600",
                                )}
                              >
                                {masterItem
                                  ? getStockDisplay(masterItem)
                                  : item.currentStock}
                              </span>
                            </TableCell>
                            {/*  Purchase Type ----------------------------- */}
                            <TableCell className="text-center">
                              <Select
                                value={item.purchaseUnitType || "Loose"}
                                onValueChange={(value) =>
                                  handleUpdatePurchaseUnitType(item.id, value)
                                }
                              >
                                <SelectTrigger className="w-[110px] mx-auto">
                                  <SelectValue placeholder="Select Type" />
                                </SelectTrigger>
                                <SelectContent className="max-h-60 overflow-y-auto">
                                  {purchaseUnitTypes
                                    .filter((type) => {
                                      const typeName = type.purchase_type_name;

                                      // 1. Loose hamesha show karo
                                      if (typeName === "Loose") return true;

                                      // 2. Original value use karo — jo API se aayi thi, change na ho
                                      return (
                                        typeName ===
                                        item.originalPurchaseUnitType
                                      );
                                    })
                                    .map((type) => (
                                      <SelectItem
                                        key={type.primary_id}
                                        value={type.purchase_type_name}
                                      >
                                        {type.purchase_type_name}
                                      </SelectItem>
                                    ))}
                                </SelectContent>
                              </Select>
                            </TableCell>
                            {/*  Qty ----------------------------- */}
                            <TableCell className="text-center">
                              {item.purchaseUnitType?.toLowerCase() ==
                                "loose" ? (
                                <span className="text-muted-foreground">—</span>
                              ) : (
                                <>
                                  <Input
                                    type="number"
                                    min="1"
                                    value={item.quantity}
                                    onChange={(e) =>
                                      handleUpdateQuantity(
                                        item.id,
                                        Number(e.target.value),
                                      )
                                    }
                                    className="w-16 text-center mx-auto"
                                  />
                                  <span
                                    className="text-[10px]"
                                    style={{ color: "#777", fontWeight: "500" }}
                                  >
                                    {item.purchaseUnitType?.toLowerCase() !==
                                      "loose" ? (
                                      item.purchaseUnitType
                                    ) : (
                                      <>
                                        {unitTypes.find(
                                          (u) => u.unit_name === item.unit,
                                        )?.short_code_name || ""}
                                      </>
                                    )}
                                  </span>
                                </>
                              )}
                            </TableCell>
                            {/*  Each Contains ----------------------------- */}
                            <TableCell className="text-center">
                              {/* {item.purchaseUnitType?.toLowerCase() !==
                              "loose" ? ( */}
                              <>
                                <Input
                                  type="number"
                                  min="1"
                                  step="0.01"
                                  value={item.sizePerPacket || "1"}
                                  onChange={(e) =>
                                    handleUpdateSizePerPacket(
                                      item.id,
                                      Number(e.target.value),
                                    )
                                  }
                                  className="w-20 text-center mx-auto"
                                />
                                <span
                                  className="text-[10px]"
                                  style={{ color: "#777", fontWeight: "500" }}
                                >
                                  {unitTypes.find(
                                    (u) =>
                                      u.unit_name === item.unit ||
                                      u.short_code_name === item.unit,
                                  )?.short_code_name || ""}
                                </span>
                              </>
                              {/* ) : (
                               <span className="text-muted-foreground">—</span>
                               )} */}
                            </TableCell>
                            {/* Unit ----------------------------- */}
                            <TableCell className="text-center">
                              <Select
                                value={item.default_unit_id?.toString() || ""}
                                onValueChange={(value) =>
                                  handleUpdateUnit(item.id, value)
                                }
                              >
                                <SelectTrigger className="w-[90px] mx-auto">
                                  <SelectValue />
                                </SelectTrigger>
                                <SelectContent>
                                  {unitsForItem(item).map((type) => (
                                    <SelectItem
                                      key={type.primary_id}
                                      value={type.primary_id.toString()}
                                    >
                                      {type.short_code_name}
                                    </SelectItem>
                                  ))}
                                </SelectContent>
                              </Select>
                            </TableCell>
                            {/* Total ---------------------------------------- */}
                            <TableCell className="text-center">
                              <span className="font-semibold">
                                {item.purchaseUnitType?.toLowerCase() ===
                                  "loose"
                                  ? item.sizePerPacket
                                  : (
                                    item.quantity * item.sizePerPacket
                                  ).toFixed(2)}
                              </span>
                            </TableCell>
                            <TableCell>
                              <Button
                                variant="ghost"
                                size="sm"
                                onClick={() => handleRemoveItem(item.id)}
                                className="text-destructive hover:text-destructive hover:bg-destructive/10"
                              >
                                <Trash2 className="w-4 h-4" />
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              </CardContent>
            </Card>
          )}

          {/* Remarks */}
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Remarks (Optional)</CardTitle>
            </CardHeader>
            <CardContent>
              <Textarea
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                placeholder="Add any notes or special instructions..."
                rows={3}
              />
            </CardContent>
          </Card>

          {/* Order Summary Section - Moved Here */}
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Order Summary</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-3">
                <div className="flex justify-between text-sm">
                  <span className="text-muted-foreground">Department</span>
                  <Badge variant="outline">{selectedDepartment}</Badge>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-muted-foreground">Vendor</span>
                  <span className="text-foreground font-medium">
                    {selectedVendor || "-"}
                  </span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-muted-foreground">Total Items</span>
                  <Badge className="bg-primary text-primary-foreground">
                    {poItems.length}
                  </Badge>
                </div>
              </div>

              <Button
                className="w-full gap-2 gradient-primary text-primary-foreground"
                disabled={poItems.length === 0 || !selectedVendor}
                onClick={handleSaveChanges}
              >
                <Send className="w-4 h-4" />
                Generate PO
              </Button>
            </CardContent>
          </Card>

          {/* Low Stock Alerts Section - Moved Here */}
          {lowStockItems.length > 0 && (
            <Card className="border-amber-200 bg-amber-50/50">
              <CardHeader>
                <div className="flex items-center gap-2">
                  <AlertTriangle className="w-5 h-5 text-amber-600" />
                  <CardTitle className="text-base text-amber-900">
                    Low Stock Alert
                  </CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                  {lowStockItems.map((item) => (
                    <button
                      key={item.id}
                      onClick={() => handleAddItem(item)}
                      className="text-left p-3 rounded-lg border border-amber-200 hover:bg-amber-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      disabled={poItems.some((p) => p.itemId === item.id)}
                    >
                      <p className="text-sm font-medium text-amber-900">
                        {item.name}
                      </p>
                      <p className="text-xs text-amber-700 mt-1">
                        {getStockDisplay(item)}
                      </p>
                    </button>
                  ))}
                </div>
              </CardContent>
            </Card>
          )}
        </div>
      </div>
      {(showLoaderAdmin || showLoader) && <Loader />}
    </MainLayout>
  );
}
